export default __webpack_public_path__ + "static/media/shape2.a3a347b5.png";